'use client';

import { useEffect } from 'react';
import { useMultistepForm } from '../../../../form-controls/MultistepForm/hooks/useMultistepForm';

type BackHandlerProps = {
  onStepInfo: (currentStepIndex: number, goBack: () => void, skipToStep: (stepId: string) => void) => void;
};

function BackHandler({ onStepInfo }: BackHandlerProps) {
  const { currentStepIndex, goToPreviousStep, skipToStep } = useMultistepForm();

  useEffect(() => {
    onStepInfo(currentStepIndex, goToPreviousStep, skipToStep);
  }, [currentStepIndex, goToPreviousStep, skipToStep, onStepInfo]);

  return null;
}

export { BackHandler };
